__turbopack_context__.v({
  "body": "CardRowSkeleton-module__Z3eY1a__body",
  "card": "CardRowSkeleton-module__Z3eY1a__card",
  "line": "CardRowSkeleton-module__Z3eY1a__line",
  "media": "CardRowSkeleton-module__Z3eY1a__media",
  "row": "CardRowSkeleton-module__Z3eY1a__row",
  "shimmer": "CardRowSkeleton-module__Z3eY1a__shimmer",
  "short": "CardRowSkeleton-module__Z3eY1a__short",
  "titleLine": "CardRowSkeleton-module__Z3eY1a__titleLine",
  "titleMediaCard": "CardRowSkeleton-module__Z3eY1a__titleMediaCard",
  "titleMediaHeader": "CardRowSkeleton-module__Z3eY1a__titleMediaHeader",
});
